<template>
  <div class="FreeMemberRemoval2">
    <section-header  heading="2" ja="無料会員削除完了" />
    <div class="description">
      {{ description }}
    </div>
  </div>
</template>

<script>
import SectionHeader from "../components/SectionHeader"

export default {
  name: "FreeMemberRemoval2",
  components: {
    SectionHeader,
  },
  data() {
    return {
      description: '無料会員を削除しました。\n　ご利用ありがとうございました。'
    }
  },
  methods: {
    onHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.description {
  color: #5e5e5e;
  font-size: 12px;
  margin: 40px 0px;
  text-align: center;
  white-space: pre-wrap;
  width: 100%;
}
.home-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
